export { default } from './AccountTransferSetupSelectTransferTypeTemplate';
